import {
  namedOperations,
  useCreateInstagramUserHashtagMutation,
  useDeleteInstagramUserHashtagMutation
} from '@anytag/graphql';
import { TagsListProps } from '../../../shared';

interface Props {
  countryId: string;
}

export const useCreateDeleteInstagramHashtag = ({ countryId }: Props) => {
  const { callCreateInstagramUserHashtag, loading: creating } = useCreateInstagramUserHashtagMutation({
    refetchQueries: [namedOperations.Query.InstagramUserHashtags]
  });
  const { callDeleteInstagramUserHashtag, loading: deleting } = useDeleteInstagramUserHashtagMutation({
    refetchQueries: [namedOperations.Query.InstagramUserHashtags]
  });

  const handleCreateHashtag: TagsListProps['onCreateTag'] = async (label) => {
    await callCreateInstagramUserHashtag({ variables: { input: { countryId, hashtag: label } } });
  };

  const handleDeleteHashtag: TagsListProps['onDeleteTag'] = async (tag) => {
    await callDeleteInstagramUserHashtag({ variables: { input: { countryId, hashtagId: tag.id } } });
  };

  return {
    creating,
    deleting,
    handleCreateHashtag,
    handleDeleteHashtag
  };
};
